import { Button, Col, Row, Typography, message } from "antd";
import { useSelector } from "react-redux";
import { useFormContext } from "react-hook-form";

import {
  selectIsUpdateKit,
  selectKitForUpdate,
} from "../../../../redux";
import { DataKits } from "../../../../redux/@types";
import {
  InputNumber,
  InputSelect,
  InputText,
} from "../../../../shared/components";
import Upload from "../../../../shared/components/ui/inputs/Upload";
import { PATH_S3_BUCKET } from "../../../../shared/utils/constants";
import { useKits } from "../../hooks";

const { Title } = Typography;

export const KitsForm = () => {
  const isUpdateKit = useSelector(selectIsUpdateKit);
  const updateKit = useSelector(selectKitForUpdate);
  const { isLoading, onSubmitCreateOrUpdate } = useKits();

  const {
    control,
    handleSubmit: onSubmit,
    setValue,
    watch,
  } = useFormContext<DataKits>();
  const imagePath = watch("image");

  return (
    <Row justify="start" gutter={[8, 8]} style={{ width: "100%", padding: 10 }}>
      <Col span={24}>
        <Title
          style={{ marginBottom: "1.5px", color: "var(--primary)" }}
          level={2}
        >
          {isUpdateKit
            ? `Actualizando kit: ${updateKit?.id}`
            : `Creando kit`}
        </Title>
      </Col>

      <Col
        span={12}
        style={{
          display: "flex",
          marginTop: "10px",
          padding: 5,
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Nombre:
        </Title>
        <InputText placeHolder="Kit de inicio" name="name" control={control} />
      </Col>

      <Col
        span={12}
        style={{
          display: "flex",
          marginTop: "10px",
          padding: 5,
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Estado:
        </Title>
        <InputSelect
          name="status"
          control={control}
          dataOptions={[
            { title: "Activo", value: "active" },
            { title: "Inactivo", value: "inactive" },
          ]}
          label="Estado"
        />
      </Col>

      <Col
        span={12}
        style={{
          display: "flex",
          marginTop: "10px",
          padding: 5,
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Audiencia:
        </Title>
        <InputSelect
          name="audience"
          control={control}
          dataOptions={[
            { title: "Estudiantes", value: "estudiantes" },
            { title: "Comercial", value: "comercial" },
          ]}
          label="Audiencia"
        />
      </Col>

      <Col
        span={12}
        style={{
          display: "flex",
          marginTop: "10px",
          padding: 5,
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Precio:
        </Title>
        <InputNumber placeHolder="0" name="price" control={control} min />
      </Col>

      <Col
        span={12}
        style={{
          display: "flex",
          marginTop: "10px",
          padding: 5,
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Clase:
        </Title>
        <InputText placeHolder="Micropigmentación" name="clase" control={control} />
      </Col>

      <Col
        span={12}
        style={{
          display: "flex",
          marginTop: "10px",
          padding: 5,
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Etiquetas (una por línea):
        </Title>
        <InputText
          placeHolder={"Academia\nIniciación"}
          name="eyebrow"
          control={control}
          rows
        />
      </Col>

      <Col
        span={12}
        style={{
          display: "flex",
          marginTop: "10px",
          padding: 5,
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Destacado:
        </Title>
        <InputSelect
          name="featured"
          control={control}
          dataOptions={[
            { title: "Sí", value: "true" },
            { title: "No", value: "false" },
          ]}
          label="Destacado"
        />
      </Col>

      <Col
        span={12}
        style={{
          display: "flex",
          marginTop: "10px",
          padding: 5,
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Prioridad:
        </Title>
        <InputNumber placeHolder="0" name="priority" control={control} min />
      </Col>

      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          padding: 5,
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Descripción:
        </Title>
        <InputText
          placeHolder="Descripción del kit..."
          name="description"
          control={control}
          rows
        />
      </Col>

      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          padding: 5,
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Ideal para (opcional):
        </Title>
        <InputText
          placeHolder="Una línea por opción"
          name="ideal_for"
          control={control}
          rows
        />
      </Col>

      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          padding: 5,
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Imagen:
        </Title>
        {imagePath ? (
          <img
            src={`${PATH_S3_BUCKET}/${imagePath}`}
            alt="kit"
            style={{
              marginBottom: "7px",
              width: "100%",
              maxWidth: "250px",
              maxHeight: "250px",
              objectFit: "cover",
            }}
          />
        ) : null}
        <Upload
          filePath="kits"
          onUploadedFile={(files) => {
            const file = files[0];
            setValue("image", file.fileKey);
            message.success("Se ha actualizado la imagen");
          }}
        />
      </Col>

      <Col span={24} style={{ marginTop: 16 }}>
        <Button
          type="primary"
          shape="round"
          size="large"
          loading={isLoading}
          onClick={onSubmit(onSubmitCreateOrUpdate)}
        >
          {isUpdateKit ? "Actualizar información" : "Crear kit"}
        </Button>
      </Col>
    </Row>
  );
};
